import React, { useState } from 'react';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { Link, useParams } from 'react-router-dom';
import { CaretLeftIcon } from '@phosphor-icons/react';
import { getOffice } from 'api/offices';
import { useQuery } from '@tanstack/react-query';
import { getPermissions } from 'api/permissions';
import Button from 'components/Button';
import AddUserToOfficePopup from 'components/Offices/OfficeAddUserPopup';

export default function Office() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const [searchUsers, setSearchUsers] = useState('');
    const [addUserPopup, setAddUserPopup] = useState(false);
    const { officeId } = useParams();

    const { data: office } = useQuery({
        queryKey: ['offices',],
        queryFn: async () => await getOffice(
            officeId
        ),
    });

    const { data: permissions } = useQuery({
        queryKey: ['permissions', 'office', officeId],
        queryFn: async () => await getPermissions({
            params: {
                element: officeId,
                elementType: 'offices'
            }
        })
    });

    function removeUserHandler(id) {
        console.log('remove user', id);
    }

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container>
                    <div className='pb-8 pt-20 md:pt-14 flex gap-3 items-center'>
                        <Link to="/settings/offices" className=''>
                            <CaretLeftIcon size={26} className='text-black hover:text-muted' />
                        </Link>
                        <p className='text-3xl'>{office?.name}</p>
                    </div>

                    <div className='w-full flex justify-between items-center'>
                        <form>
                            <input
                                type="text"
                                placeholder='Cerca utenti...'
                                className='w-full bg-white border border-light text-sm rounded-sm focus:ring-0 focus:outline-none focus:border-grey placeholder:text-muted px-4 py-3 min-w-[400px] w-[400px] block'
                                onChange={(e) => setSearchUsers(e.target.value)}
                            />
                        </form>

                        <Button onClick={() => setAddUserPopup(true)}>
                            Aggiungi utente
                        </Button>
                    </div>

                    <div className='border border-light rounded-sm mt-6'>
                        {(!permissions || permissions?.length === 0) && (
                            <div className='p-4'>
                                <p className='text-muted'>Nessun utente collegato a questo ufficio.</p>
                            </div>
                        )}
                        {permissions?.filter((permission) => {
                            const { user } = permission;
                            if (user) {
                                return user.firstname.toLowerCase().includes(searchUsers.toLowerCase()) || user.lastname.toLowerCase().includes(searchUsers.toLowerCase());
                            }
                            return null;
                        }).map((permission, index) => {

                            const { user, auth } = permission;

                            return (user &&
                                <div key={index} className='group border-b last:border-0 border-light flex items-center gap-4 p-4'>
                                    <div className='flex-1'>
                                        <p className='font-semibold'>{user.firstname} {user.lastname}</p>
                                    </div>
                                    <div className='flex-1'>
                                        <p className=''>{auth}</p>
                                    </div>

                                    <div className='opacity-0 group-hover:opacity-100 flex-1 flex gap-4 justify-end items-center'>
                                        <Link to={`/settings/users/${user._id}`} className='hover:underline'>
                                            Vedi profilo
                                        </Link>

                                        <div className='hover:text-red-400 hover:underline cursor-pointer' onClick={() => removeUserHandler(user._id)}>
                                            Rimuovi
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </Container>
            </div>

            <AddUserToOfficePopup
                visible={addUserPopup}
                setVisible={setAddUserPopup}
                presentUsers={permissions?.filter(({ user }) => !!user).map(permission => permission.user?._id)}
            />
        </>
    )
}
